import { DonationFrequency } from '@web/graphql-components'
import { PaymentMethodType, PaymentSettings } from '@web/graphql-queries/graphql'
import { create } from 'zustand'

type PaymentStoreActions = {
  setPrevAmount: (prevAmount: number) => void
  setPrevEmail: (prevEmail: string) => void
  setPaymentMethodType: (paymentMethodType: PaymentMethodType) => void
  setPrevGivingFrequency: (prevGivingFrequency: DonationFrequency) => void
  setPrevIsDonorPays: (prevIsDonorPays: boolean) => void
}

type PaymentStore = {
  clientSecret: string
  prevAmount: number
  prevEmail: string
  prevGivingFrequency: DonationFrequency
  prevIsDonorPays: boolean
  prevIsPayByInstallments: boolean
  paymentTransactionId: string | null
  paymentSubscriptionId: string | null
  paymentIntentId: string
  paymentMethodType: PaymentMethodType | null
  subscriptionId: string | null
  paymentSettings: PaymentSettings | null
  showDataCollectionPopup: boolean
  hasLoaded: boolean
  actions: PaymentStoreActions
  paymentError?: string
}

export const QUICK_PAY_PAYMENT_METHOD_TYPES = [
  PaymentMethodType.ApplePay,
  PaymentMethodType.GooglePay,
  PaymentMethodType.PayPal,
]

export const usePaymentStore = create<PaymentStore>((set) => ({
  clientSecret: '',
  prevAmount: 0,
  prevEmail: '',
  prevGivingFrequency: DonationFrequency.OneTime,
  paymentTransactionId: '',
  paymentSubscriptionId: '',
  paymentIntentId: '',
  paymentMethodType: null,
  subscriptionId: null,
  paymentSettings: null,
  hasLoaded: false,
  showDataCollectionPopup: false,
  prevIsDonorPays: false,
  prevIsPayByInstallments: false,
  actions: {
    setPrevAmount: (prevAmount) => set(() => ({ prevAmount })),
    setPrevEmail: (prevEmail) => set(() => ({ prevEmail })),
    setPaymentMethodType: (paymentMethodType) => set(() => ({ paymentMethodType })),
    setPrevGivingFrequency: (prevGivingFrequency) => set(() => ({ prevGivingFrequency })),
    setPrevIsDonorPays: (prevIsDonorPays) => set(() => ({ prevIsDonorPays })),
  },
}))
